// extracted by mini-css-extract-plugin
export default {"page":"XT","freeShippingContainer":"YT","customizeContainer":"ZT","customizeHeader":"aU","fadein":"bU","customizeText":"cU","hidden":"eU","productcard":"fU","accordeonscontainer":"gU","freeShipping":"hU","mainpart":"iU"};
    if(module.hot) {
      // 1737143663218
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  